module.exports = "<div class=\"container-fluid text-center\">\n   <img src=\"./assets/svip.jpg\" class=\"img-fluid\">\n</div> \n"